import { Link } from 'react-router-dom';
import { brand, categories, navLinks } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-background-100 mt-auto">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                揭
              </span>
              <strong className="font-heading text-lg font-bold">{brand.name}</strong>
            </div>
            <p className="mt-4 text-sm text-background-200 leading-relaxed">{brand.intro}</p>
            <p className="mt-4 text-xs text-background-300 leading-relaxed">{brand.statement}</p>
            <div className="mt-5 flex items-center gap-3">
              <a href={`mailto:${brand.email}`} className="w-9 h-9 rounded-md bg-secondary-800 flex items-center justify-center text-background-100 hover:bg-primary-600 transition-colors" aria-label="邮箱联系">
                <i className="ri-mail-line" />
              </a>
              <a href={`mailto:${brand.cooperation}`} className="w-9 h-9 rounded-md bg-secondary-800 flex items-center justify-center text-background-100 hover:bg-primary-600 transition-colors" aria-label="合作投稿">
                <i className="ri-send-plane-line" />
              </a>
              <Link to="/about" className="w-9 h-9 rounded-md bg-secondary-800 flex items-center justify-center text-background-100 hover:bg-primary-600 transition-colors" aria-label="关于我们">
                <i className="ri-information-line" />
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50">
              <Link to="/feed" className="hover:text-accent-400 transition-colors">线报栏目</Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/feed?cat=${cat.id}`} className="text-sm text-background-200 hover:text-accent-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50">站点导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-background-200 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/#hot" className="text-sm text-background-200 hover:text-accent-400 transition-colors">24 小时热榜</Link>
              </li>
              <li>
                <Link to="/#subscribe" className="text-sm text-background-200 hover:text-accent-400 transition-colors">订阅线报</Link>
              </li>
              <li>
                <a href={`mailto:${brand.email}`} className="text-sm text-background-200 hover:text-accent-400 transition-colors">联系我们</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © {year} {brand.name} · {brand.fullName}
          </p>
          <p className="text-xs text-background-300">
            始于 {brand.founded} · 内容基于公开信息整理，仅供参考
          </p>
        </div>
      </div>
    </footer>
  );
}